/**
 * Capabilities the founder has taken out of MVP scope — the frontend mirror of
 * `app/services/product_scope.py`.
 *
 * The backend refuses POST /domains/purchase with a 403 while domain resale is
 * descoped. Without this mirror the onboarding wizard still invited every new
 * org to "Connect a domain" and handed them to a checkout that could only
 * refuse. `tests/test_the_descoped_domain_purchase_is_not_offered.py` fails if
 * the two constants disagree, so flipping one without the other is a red build.
 */

export const DOMAIN_RESALE_IN_SCOPE = false;

export const DOMAIN_RESALE_DESCOPED_MESSAGE =
  "Domain purchase is not available. Domain resale is outside the current " +
  "product scope, so no domain can be bought or renewed through FTL.";
